export function formatRupiah(n) {
  const val = Math.round(Number(n) || 0);
  return "Rp " + val.toLocaleString("id-ID");
}

export function formatDate(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("id-ID", {
      day: "2-digit", month: "short", year: "numeric",
    });
  } catch { return iso; }
}

export function formatDateTime(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("id-ID", {
      day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch { return iso; }
}

export const ROLE_LABELS = {
  it_admin: "IT Admin",
  direktur: "Direktur",
  approver: "Approver",
  tim_keuangan: "Tim Keuangan",
  pemohon: "Pemohon",
  staf_tagihan: "Staf Input Tagihan",
  tim_kendaraan: "Tim Kendaraan",
};

export const BILL_STATUS_META = {
  pending: { label: "Menunggu Rencana", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  planned: { label: "Rencana Ditetapkan", cls: "bg-sky-100 text-sky-800 border-sky-200" },
  paid: { label: "Sudah Dibayar", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
};

export const PAYMENT_TYPE_LABEL = { harian: "Harian", jatuh_tempo: "Jatuh Tempo", bilyet_giro: "Bilyet Giro" };

export const REMINDER_META = {
  ok: { label: "Aman", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  upcoming: { label: "Segera", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  overdue: { label: "Terlambat", cls: "bg-red-100 text-red-700 border-red-200" },
  perlu_diskusi: { label: "Perlu Diskusi", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  unknown: { label: "Belum Diisi", cls: "bg-slate-100 text-slate-500 border-slate-200" },
};

export const STATUS_META = {
  pending: { label: "Menunggu Approval", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  approved: { label: "Disetujui", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  disbursed: { label: "Kas Dicairkan", cls: "bg-sky-100 text-sky-800 border-sky-200" },
  rejected: { label: "Ditolak", cls: "bg-red-100 text-red-700 border-red-200" },
  completed: { label: "Selesai", cls: "bg-slate-200 text-slate-700 border-slate-300" },
};

export const AUDIT_ACTION_LABELS = {
  user_create: "Buat User",
  user_update: "Ubah User",
  user_delete: "Hapus User",
  request_create: "Ajukan Kas",
  request_approve: "Setujui Pengajuan",
  request_reject: "Tolak Pengajuan",
  request_disburse: "Cairkan Kas",
  expense_proof: "Upload Bukti",
  approver_appoint: "Tunjuk Approver",
  approver_revoke: "Cabut Approver",
  bill_create: "Input Tagihan",
  bill_plan: "Rencana Pembayaran",
  bill_pay: "Bayar Tagihan",
  vehicle_create: "Tambah Kendaraan",
  vehicle_update: "Ubah Kendaraan",
  vehicle_delete: "Hapus Kendaraan",
  vehicle_maintenance: "Bukti Kendaraan",
  branch_create: "Tambah Cabang",
  branch_update: "Ubah Cabang",
  branch_delete: "Hapus Cabang",
};
